import React from 'react';
import Text from '@components/Text/Text';
import { PromotionCard, AvailableContent, AppStore } from './PromotionWidget.styled';
import { UIConstants, AmplifyLogs } from '@constants';
import { MobielWidgetProps } from '@components/types';

const PromotionWidget: React.FC<MobielWidgetProps> = ({ component }) => {
    const { availableOn, downloadApp, googlePlay, appStore, smartLink, imgSrcGooglePlay, imgSrcAppStore } = UIConstants.promotionWidget;

    const { action, description } = AmplifyLogs.promotionWidget;
    const device = navigator.userAgent;

    const androidDevice = device.match(/Android/i);
    const ipadDevice = device.match(/iPad/i);
    const macDevice = device.match(/Mac/i) && !device.match(/Macintosh/i);

    const openApp = () => {
        window.open(smartLink, '_blank');
    };
    return (
        <PromotionCard id="promotionWidget">
            <AvailableContent id="appStoreContent">
                <Text textVariant="h3">{(androidDevice || macDevice) && !ipadDevice ? availableOn : downloadApp}</Text>
                {(androidDevice || !macDevice) && (
                    <AppStore
                        id="GooglePlay"
                        onClick={openApp}
                        eventAttributes={{
                            type: component,
                            action
                        }}
                    >
                        <img src={imgSrcGooglePlay} alt="GooglePlay" />
                        <Text textVariant="h3">{googlePlay}</Text>
                    </AppStore>
                )}
                {(macDevice || !androidDevice) && (
                    <AppStore
                        id="AppStore"
                        onClick={openApp}
                        eventAttributes={{
                            type: component,
                            action,
                            description
                        }}
                    >
                        <img src={imgSrcAppStore} alt="AppStore" />
                        <Text textVariant="h3">{appStore}</Text>
                    </AppStore>
                )}
            </AvailableContent>
        </PromotionCard>
    );
};
export default PromotionWidget;
